import { action } from 'typesafe-actions';

import { IWorld, WorldsTypes } from './types';

export const loadRequest = () => action(WorldsTypes.LOAD_REQUEST);
export const loadSuccess = (world: IWorld) => action(WorldsTypes.LOAD_SUCCESS, { world });
export const loadFailure = () => action(WorldsTypes.LOAD_FAILURE);
